
import './App.css';
import Home from './Components/Home';
import About from './Components/About';
import Resume from './Components/Resume';
import Services from './Components/Services';
import Portfolio from './Components/Portfolio';
import Contact from './Components/Contact';

function App() {
  return (
    <div className="App">
      <Home />
      <About />
      <Resume/>
      <Services/>
      <Portfolio/> 
      <Contact/>
      
    </div>
  );
}

export default App;
